module.exports = __webpack_public_path__ + "static/img/HN.f6e32570.svg";